import React, { useState, useRef } from 'react';
import { Row, Col, Button, FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import { uploadAccountsFile } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function ImportAccounts(props) {
    const [results, setResults] = useState(null);
    const [processingFile, setProcessingFile] = useState(false);
    const [overwriteFees, setOverwriteFees] = useState(false);
    const fileEl = useRef(null);
    const [file, setFile] = useState(null);

    const updateFile = (e) => {
        setFile(e.target.files[0]);
    };

    const processFile = async () => {
        try {
            setResults(null);
            setProcessingFile(true);

            const formData = new FormData();

            // Update the formData object
            formData.append(
                "FileToUpload",
                file,
                file.name
            );

            const response = await uploadAccountsFile(formData);
            console.log(response);

            setResults({ success: true, ...response });
            //setResults({ success: !results?.success ?? false, recordsAdded: 3, recordsUpdated: 12 });
        } catch (ex) {
            console.log(ex);
            setResults({ success: false, message: 'Failed to import file.' });
        } finally {
            setProcessingFile(false);
        }
    };

    let resultsJSX = null;
    if (results) {
        if (results.success) {
            resultsJSX = (
                <div className="import-results success">
                    <span>{results.accountRecordsAdded} account records added.</span>
                    <span>{results.accountRecordsUpdated} account records updated.</span>
                </div>
            );
        } else {
            resultsJSX = (
                <div className="import-results failure">
                    <span>{results.message}</span>
                </div>
            );
        }
    }

    return (
        <div id="importAccounts" className="import-content">
            <div className="import-inputs">
                <FormGroup>
                    <div className="tooltip-parent">
                        <Input type="file" ref={fileEl} onChange={updateFile} />
                        <div className="tooltip-target tooltip-top">
                            Accounts File
                        </div>
                    </div>
                </FormGroup>
            </div>
            <div className="import-buttons">
                <Button className="btn-block btn-icon" color="danr-green" onClick={processFile} disabled={processingFile}><i className="fas fa-upload"></i><span>Process File</span></Button>
            </div>
            {resultsJSX}
            {processingFile ? (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>) : null}
        </div>
    );
}

export default ImportAccounts;